import secondaryButton from '../../secondary-button/branded-solid/background/default';

const secondary = (params) => secondaryButton.secondary(params);

export default secondary;
